var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('div',{staticClass:"nowifi text-center"},[_c('img',{staticClass:"nowifiimg",attrs:{"src":_vm.wifislash,"alt":""}}),_c('h3',[_vm._v("ADK Payment Request Portal")]),_c('h4',[_vm._v("ADK Hospital")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }